module.exports = __webpack_public_path__ + "img/nodejs.6d2242a.svg";